import { catchError } from 'rxjs/operators';
import { HttpRequest, HttpHandler, HttpEvent, HttpErrorResponse, HttpInterceptor } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';

import { AppConstants } from '../../app.constants';

import { AuthService } from '../../services/auth.service';
import { AppUtilityService } from '../../services/appUtilityService.service';

@Injectable({
  providedIn: 'root',
})
export class HttpRequestInterceptor implements HttpInterceptor {
  constructor(
    public appUtilityService: AppUtilityService,
    private authService: AuthService
  ) { }

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    return next
      .handle(this.addRequestIdHeader(request))
      .pipe(catchError((error: HttpErrorResponse) => this.handleError(error)));
  }

  handleError(error: HttpErrorResponse) {
    let errorMessage = '';
    if (error.status === 401) {
      errorMessage = AppConstants.ErrorSessionTimeout;
    } else {
      if (error.error instanceof ErrorEvent) {
        // client-side error
        errorMessage = error.error.message;
      } else {
        // server-side error
        if (error.error instanceof Array && error.error.length > 0) {
          errorMessage = error.error.map((x) => x.message).join('; ');
        } else {
          errorMessage = error.message;
        }
      }
    }
    console.log(errorMessage);
    return throwError(() => errorMessage);
  }

  addRequestIdHeader(request: HttpRequest<any>) {
    return request.clone({
      setHeaders: {
        'Request-Id': this.appUtilityService.createNewGuid(),
        Token: this.authService.accessToken,
      },
    });
  }
}
